import { render, staticRenderFns } from "./Card5.vue?vue&type=template&id=6bfeec72&scoped=true&"
import script from "./Card5.vue?vue&type=script&lang=js&"
export * from "./Card5.vue?vue&type=script&lang=js&"
import style0 from "./Card5.vue?vue&type=style&index=0&id=6bfeec72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfeec72",
  null
  
)

export default component.exports